import React, { FC } from 'react';
import cx from 'classnames';
import { isNaN, isNil } from 'lodash';

import './Amount.scss';

type Props = {
  showDollarSign?: boolean;
  highlightIntegerValue?: boolean;
  highlightFractionalValue?: boolean;
  coinsAmount: number;
  className?: string;
  customCoinsFormat?: (value: number) => string;
  defaultValue?: string | number;
  defaultZeroValue?: string | number;
  testId?: string;
};

export const Amount: FC<Props> = ({
  showDollarSign,
  highlightIntegerValue,
  highlightFractionalValue,
  coinsAmount,
  className,
  customCoinsFormat,
  defaultValue = '',
  defaultZeroValue,
  testId
}) => {
  function getContent(): string | number | JSX.Element {
    if (isNil(coinsAmount) || isNaN(coinsAmount)) {
      return defaultValue;
    }
    if (coinsAmount === 0 && (defaultZeroValue || defaultZeroValue === '' || defaultZeroValue === 0)) {
      return defaultZeroValue;
    }
    const amountIsNegative: boolean = coinsAmount < 0;
    const splitAmount: Array<string> = formatAndCreateArrayOfBeforeAndAfterDotsValue();

    return (
      <React.Fragment>
        {amountIsNegative && '('}
        <span className={cx({ 'eds-highlight-integer': highlightIntegerValue })}>
          {showDollarSign && '$'}
          {splitAmount[0]}
        </span>
        <span className={cx({ 'eds-highlight-fractional': highlightFractionalValue })}>{`.${splitAmount[1]}`}</span>
        {amountIsNegative && ')'}
      </React.Fragment>
    );
  }

  return (
    <div className={cx('eds-amount', className)} data-testid={testId}>
      {getContent()}
    </div>
  );

  function formatAndCreateArrayOfBeforeAndAfterDotsValue(): Array<string> {
    function formatAmount(): string {
      if (customCoinsFormat) {
        return customCoinsFormat(Math.abs(coinsAmount));
      }
      const amount: number = Math.abs(coinsAmount);
      return (amount / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const formattedAmount = formatAmount();
    return formattedAmount.split('.');
  }
};
